
import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "./components/Footer";
import banner137 from "../src/assets/images/Banner_137_updated.jpg";
import PAN_DoB_Notice_V2 from "../src/assets/images/PAN_DoB_Notice_V2.png";
import addressUpdateBanner from "../src/assets/images/Address Update Banner.png";
import Digilocker_Banner_V2 from "../src/assets/images/Digilocker_Banner_V2.png";
import TRACES_Banner_English from "../src/assets/images/TRACES_TDS_TCS_Online_Filing_Banner_English_18.09.26.cleaned.jpg";
import TRACES_Banner_Hindi from "../src/assets/images/TRACES_TDS_TCS_Online_Filing_Banner_Hindi_18.09.26.cleaned.jpg";

function App() {
  const location = useLocation();

  // Set initial state to showPanDoBNotice first, then showAddressUpdatePopup, then showDigilockerPopup, then showTracesEnglishPopup, then showTracesHindiPopup, then showBanner137Popup
  const [showPanDoBNotice, setPanDoBNotice] = useState(true);
  const [showAddressUpdatePopup, setAddressUpdatePopup] = useState(false);
  const [showDigilockerPopup, setDigilockerPopup] = useState(false);
  const [showTracesEnglishPopup, setTracesEnglishPopup] = useState(false);
  const [showTracesHindiPopup, setTracesHindiPopup] = useState(false);
  const [showBanner137Popup, setBanner137Popup] = useState(false);


  const handlePanDoBNotice = () => {
    setPanDoBNotice(false);
    setAddressUpdatePopup(true); // 2nd popup is Address Update Banner
  };

  const handleAddressUpdatePopup = () => {
    setAddressUpdatePopup(false);
    setDigilockerPopup(true); // 3rd popup is DigiLocker Important Announcement
  };

  const handleDigilockerPopup = () => {
    setDigilockerPopup(false);
    setTracesEnglishPopup(true); // 4th popup is TRACES English Banner
  };

  const handleTracesEnglishPopup = () => {
    setTracesEnglishPopup(false);
    setTracesHindiPopup(true); // 5th popup is TRACES Hindi Banner
  };

  const handleTracesHindiPopup = () => {
    setTracesHindiPopup(false);
    setBanner137Popup(true); // 6th popup is Form 137 TRACES Banner
  };

  const handleBanner137Popup = () => {
    setBanner137Popup(false);
  };


  // ESC key handling based on new order
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        if (showPanDoBNotice) {
          setPanDoBNotice(false);
          setAddressUpdatePopup(true);
        }
        else if (showAddressUpdatePopup) {
          setAddressUpdatePopup(false);
          setDigilockerPopup(true);
        }
        else if (showDigilockerPopup) {
          setDigilockerPopup(false);
          setTracesEnglishPopup(true);
        }
        else if (showTracesEnglishPopup) {
          setTracesEnglishPopup(false);
          setTracesHindiPopup(true);
        }
        else if (showTracesHindiPopup) {
          setTracesHindiPopup(false);
          setBanner137Popup(true);
        }
        else if (showBanner137Popup) {
          setBanner137Popup(false);
        }     
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showPanDoBNotice, showAddressUpdatePopup, showDigilockerPopup, showTracesEnglishPopup, showTracesHindiPopup, showBanner137Popup]);

  return (
    <div className="app">


      {/* 1. Show PanDoBNotice 1st popup) */}
      {location.pathname === "/" && showPanDoBNotice && (
        <div className="bg-gray-500 flex absolute w-full h-full justify-center items-center z-50 bg-opacity-50">
        <div className="bg-white w-[95%] md:w-[70%] lg:w-[800px] gap-4 flex flex-col justify-center items-center rounded-xl p-4">
          
          <a href="https://www.incometaxindia.gov.in/w/rule-158-1" target="_blank" rel="noopener noreferrer">
            <img src={PAN_DoB_Notice_V2} alt="Notice Banner" className="w-full h-auto rounded-lg shadow-sm" />
          </a>
          
          
          <button
            onClick={handlePanDoBNotice}
            className="bg-orange-500 text-white px-8 py-3 rounded-md mb-2 font-bold text-lg transition-transform hover:scale-105"
          >
            Continue
          </button>
        </div>
      </div>
      )}

      {/* 2. Show Address Update Banner 2nd popup) */}
      {location.pathname === "/" && showAddressUpdatePopup && (
        <div className="bg-gray-500 flex absolute w-full h-full justify-center items-center z-50 bg-opacity-50">
        <div className="bg-white w-[95%] md:w-[70%] lg:w-[800px] gap-4 flex flex-col justify-center items-center rounded-xl p-4">
          <a
            href="https://onlineservices.proteantech.in/paam/endUserAddressUpdate.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={addressUpdateBanner} alt="Address Update Facility" className="w-full h-auto rounded-lg shadow-sm" />
          </a>
          <button
            onClick={handleAddressUpdatePopup}
            className="bg-orange-500 text-white px-8 py-3 rounded-md mb-2 font-bold text-lg transition-transform hover:scale-105"
          >
            Continue
          </button>
        </div>
      </div>
      )}

      {/* 3. Show DigilockerPopup 3rd popup) */}
      {location.pathname === "/" && showDigilockerPopup && (
        <div className="bg-gray-500 flex absolute w-full h-full justify-center items-center z-50 bg-opacity-50">
        <div className="bg-white w-[95%] md:w-[70%] lg:w-[800px] gap-4 flex flex-col justify-center items-center rounded-xl p-4">
          <img src={Digilocker_Banner_V2} alt="Notice Banner" className="w-full h-auto rounded-lg shadow-sm" />
          <button
            onClick={handleDigilockerPopup}
            className="bg-orange-500 text-white px-8 py-3 rounded-md mb-2 font-bold text-lg transition-transform hover:scale-105"
          >
            Continue
          </button>
        </div>
      </div>
      )}

      {/* 4. Show TRACES TDS/TCS English Banner (4th popup) */}
      {location.pathname === "/" && showTracesEnglishPopup && (
        <div className="bg-gray-500 flex absolute w-full h-full justify-center items-center z-50 bg-opacity-50 px-4">
          <div className="bg-white w-[95%] md:w-[70%] lg:w-[800px] max-h-[92vh] overflow-y-auto gap-3.5 flex flex-col justify-center items-center rounded-2xl p-4 md:p-5 shadow-2xl">
            <img
              src={TRACES_Banner_English}
              alt="TRACES TDS/TCS Online Filing Banner - English"
              className="w-full h-auto rounded-lg shadow-sm object-contain"
            />

            <a
              href="https://traces.tdscpc.gov.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 font-bold underline text-sm md:text-base inline-flex items-center gap-1"
            >
              Click Here
              <svg
                className="w-4 h-4 inline"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </a>

            <button
              onClick={handleTracesEnglishPopup}
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-2.5 rounded-md font-bold text-base transition-transform hover:scale-105 shadow-md"
            >
              Continue
            </button>
          </div>
        </div>
      )}

      {/* 5. Show TRACES TDS/TCS Hindi Banner (5th popup) */}
      {location.pathname === "/" && showTracesHindiPopup && (
        <div className="bg-gray-500 flex absolute w-full h-full justify-center items-center z-50 bg-opacity-50 px-4">
          <div className="bg-white w-[95%] md:w-[70%] lg:w-[800px] max-h-[92vh] overflow-y-auto gap-3.5 flex flex-col justify-center items-center rounded-2xl p-4 md:p-5 shadow-2xl">
            <img
              src={TRACES_Banner_Hindi}
              alt="TRACES TDS/TCS Online Filing Banner - Hindi"
              className="w-full h-auto rounded-lg shadow-sm object-contain"
            />

            <a
              href="https://traces.tdscpc.gov.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 font-bold underline text-sm md:text-base inline-flex items-center gap-1"
            >
              Click Here
              <svg
                className="w-4 h-4 inline"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </a>

            <button
              onClick={handleTracesHindiPopup}
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-2.5 rounded-md font-bold text-base transition-transform hover:scale-105 shadow-md"
            >
              Continue
            </button>
          </div>
        </div>
      )}

      {/* 6. Show Form 137 TRACES Banner Popup (6th popup) */}
      {location.pathname === "/" && showBanner137Popup && (
        <div className="bg-gray-500 flex absolute w-full h-full justify-center items-center z-50 bg-opacity-50 px-4">
          <div className="bg-white w-[95%] md:w-[85%] lg:w-[750px] max-h-[92vh] overflow-y-auto gap-3.5 flex flex-col justify-center items-center rounded-2xl p-4 md:p-5 shadow-2xl">
            <a
              href="https://traces.tdscpc.gov.in/auth/TracesRegistration/PAORegistration"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full flex justify-center"
            >
              <img
                src={banner137}
                alt="Form No. 137 TRACES Portal Notice"
                className="w-full h-auto rounded-lg shadow-sm max-h-[68vh] object-contain cursor-pointer"
              />
            </a>

            <div className="flex flex-wrap items-center justify-center gap-1.5 text-center">
              <span className="text-gray-800 font-medium text-sm md:text-base">
                For PAO Registration:
              </span>
              <a
                href="https://traces.tdscpc.gov.in/auth/TracesRegistration/PAORegistration"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 font-bold underline text-sm md:text-base inline-flex items-center gap-1"
              >
                Click here
                <svg
                  className="w-4 h-4 inline"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                  />
                </svg>
              </a>
            </div>

            <button
              onClick={handleBanner137Popup}
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-2.5 rounded-md font-bold text-base transition-transform hover:scale-105 shadow-md"
            >
              Continue
            </button>
          </div>
        </div>
      )}

      {/* 1. Show Digilocker Popup (2nd popup) */}
      {/* {location.pathname === "/" && showDigilockerPopup && (
        <div className="bg-gray-500 flex absolute w-full h-full justify-center items-center z-50 bg-opacity-50 px-4">
          <div className="bg-white w-[95%] md:max-w-[500px] rounded-3xl shadow-2xl relative overflow-hidden flex flex-col border-[6px] border-[#DCEFFC]">
            
            <div className="w-full bg-[#E5F1FC] py-3 px-4 flex items-center justify-center relative">
              <div className="absolute left-[-15px] top-[-15px] bg-white rounded-full p-2 border-4 border-[#DCEFFC] shadow-sm hidden md:flex items-center justify-center w-[70px] h-[70px]">
                <span className="text-3xl">🔔</span>
              </div>
              <h2 className="text-lg md:text-xl font-bold text-[#0B1538] tracking-wider uppercase text-center mt-1 mb-1 ml-0 md:ml-10 font-sans">
                IMPORTANT ANNOUNCEMENT
              </h2>
              
              <div className="absolute right-3 top-3 opacity-40">
                <svg width="24" height="24" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M40 0H0V40C0 17.9086 17.9086 0 40 0Z" fill="transparent" stroke="#2563EB" strokeWidth="2"/>
                </svg>
              </div>
            </div>
            
            
            <div className="p-5 md:p-6 text-center w-full relative flex flex-col items-center bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-white to-gray-50">
              
              <div className="absolute inset-0 opacity-[0.03]" style={{backgroundImage: 'radial-gradient(#000 2px, transparent 2px)', backgroundSize: '30px 30px'}}></div>
              
              <div className="relative z-10 w-full flex flex-col items-center text-[#1A202C]">
                <h3 className="text-base md:text-lg mb-4 font-semibold font-sans tracking-wide">Hi PAN Applicant!</h3>
                
                <p className="text-sm md:text-base leading-relaxed mb-5 font-normal font-sans">
                  If you're a DigiLocker-registered user, you can fetch your proof
                  of Date of Birth directly from DigiLocker for a faster PAN
                  application process.
                </p>
                
                <div className="text-sm md:text-base leading-relaxed mb-6 font-normal font-sans">
                  <p className="mb-1">Not registered yet?</p>
                  <p className="mb-1">Use the Register with DigiLocker option to sign up.</p>
                  <p>Alternatively, you can continue with manual document upload.</p>
                </div>

                <button
                  onClick={handleDigilockerPopup}
                  className="bg-[#FFBA00] hover:bg-[#E5A700] text-gray-900 px-8 py-2.5 rounded-full font-bold text-base transition-transform hover:scale-105 shadow-md"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}

export default App;